import { isTemporarySlug } from 'ContentEditorUI/utils/contentModelURLUtils';
import { FETCH_CONTENT_SCHEMA_SUCCEEDED, SEED_STAGED_PAGE_SETTINGS, UPDATE_WEBVERSION_ENABLED, FETCH_PAGE_SUCCESS, UPDATE_SETTINGS_SLUG_RAW, UPDATE_CONTENT_MODEL_EXPIRY_REDIRECT_URL, UNLINK_SLUG_FROM_TITLE, UPDATE_SETTINGS_SHOW_ALL_ERRORS, SET_SETTINGS_SCROLL_TO, FETCH_EDITABLE_SLUG_INFO_SUCCESS } from 'ContentEditorUI/redux/actions/actionTypes';
import { produce } from 'immer';
const initialStateAsJSObject = {
  showAllErrors: false
};

// NOTE This reducer contains app-settings (UI state) fields
// 'base' means it only holds fields that are shared by at least 2 projects (PEUI/BEUI/EEUI/EDNDUI)
// app-specific UI state fields belong in <app>SettingsReducer
const baseSettingsReducer = (state = initialStateAsJSObject, {
  type,
  payload,
  response
}) => produce(state, draft => {
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const {
          content
        } = response;
        return Object.assign(draft, {
          linkSlugToTitle: content.slug ? isTemporarySlug(content.slug) : false,
          pageExpiryRedirectId: content.pageExpiryRedirectId
        });
      }
    case UPDATE_WEBVERSION_ENABLED:
      draft.linkSlugToTitle = payload.createPage;
      return draft;
    case FETCH_PAGE_SUCCESS:
      {
        let redirectName = null;
        if (draft.pageExpiryRedirectId === payload.id) {
          redirectName = payload.name;
        }
        draft.pageExpiryRedirectName = redirectName;
        return draft;
      }
    case UNLINK_SLUG_FROM_TITLE:
      draft.linkSlugToTitle = false;
      return draft;
    case UPDATE_CONTENT_MODEL_EXPIRY_REDIRECT_URL:
      {
        const {
          url,
          id,
          name,
          pages
        } = payload;
        if (name && id) {
          // TODO: see if we can make this default.
          return Object.assign(draft, {
            pageExpiryRedirectId: id,
            pageExpiryRedirectName: name
          });
        }
        let newId = url ? 0 : null; // ID is 0 for external urls
        let newName = null;
        const availableRedirectPage = pages.find(page => page.url === url);
        if (availableRedirectPage) {
          newId = availableRedirectPage.id;
          newName = availableRedirectPage.name;
        }
        return Object.assign(draft, {
          pageExpiryRedirectId: newId,
          pageExpiryRedirectName: newName
        });
      }
    case UPDATE_SETTINGS_SHOW_ALL_ERRORS:
      draft.showAllErrors = payload;
      return draft;
    case UPDATE_SETTINGS_SLUG_RAW:
      if (!payload.slugRaw && !payload.htmlTitle) {
        draft.linkSlugToTitle = true;
      }
      draft.slugRaw = payload.slugRaw;
      return draft;
    case FETCH_EDITABLE_SLUG_INFO_SUCCESS:
      draft.slugRaw = payload.editableSlug;
      return draft;
    case SEED_STAGED_PAGE_SETTINGS:
      {
        const {
          name,
          slug,
          htmlTitle
        } = payload;
        draft.slugRaw = slug;
        draft.name = name;
        draft.htmlTitle = htmlTitle || '';
        draft.linkSlugToTitle = slug ? !!isTemporarySlug(slug) : false;
        return draft;
      }
    case SET_SETTINGS_SCROLL_TO:
      draft.scrollToElement = payload;
      return draft;
    default:
      return draft;
  }
});
export default baseSettingsReducer;